import { Collapse, Offcanvas, Dropdown } from 'bootstrap'

function handleOffcanvasEvents() {
  const offcanvasOffsetElement = document.querySelector('header')
  const offcanvasButton = document.getElementById('headerOffcanvasButton')
  const offcanvas = document.getElementById('headerOffcanvas')

  if (offcanvasOffsetElement && offcanvasButton && offcanvas) {
    offcanvas.addEventListener('show.bs.offcanvas', event => {
      offcanvasButton.classList.add('offcanvas-open')
      let topOffset = offcanvasOffsetElement.getBoundingClientRect().bottom
      offcanvas.style.top = `${topOffset}px`
    })

    offcanvas.addEventListener('hide.bs.offcanvas', event => {
      offcanvasButton.classList.remove('offcanvas-open')
    })
  }
}

function handleMainNavigationEvents() {
  const header = document.querySelector('#header')
  const mainNavigationDropdownLinks = document.querySelectorAll('.main-navigation-top-level-item .dropdown .main-navigation-top-level-link')
  const dropdowns = []

  mainNavigationDropdownLinks.forEach(mainNavigationDropdownLink => {
    let dropdown = Dropdown.getOrCreateInstance(mainNavigationDropdownLink, { toggle: false })
    dropdowns.push(dropdown)
  })

  for (let i = 0; i < dropdowns.length; i++) {
    let dropdownLink = mainNavigationDropdownLinks[i]
    let dropdown = dropdowns[i]

    dropdownLink.addEventListener('mouseover', event => {
      dropdowns.forEach(d => {
        d.hide()
      })
      dropdown.show()
    })
    dropdownLink.addEventListener('click', event => {
      dropdowns.forEach(d => {
        d.hide()
      })
      dropdown.show()
    })
  }

  header.addEventListener('mouseleave', event => {
    dropdowns.forEach(d => {
      d.hide()
    })
  })
}

function handleKeyboardAndMouseEvents() {
  // On escape keypress, collapse all header collapses and dropdowns
  const headerCollapses = document.querySelectorAll('header .collapse, .main-navigation-wrapper .collapse')
  const headerDropdowns = document.querySelectorAll('.main-navigation-top-level-item .dropdown .main-navigation-top-level-link')
  if (headerCollapses) {
    document.addEventListener('keydown', (event) => {
      if (event?.key === 'Escape' || event?.key === 'Esc') {
        headerCollapses.forEach((headerCollapse) => {
          const collapse = Collapse.getOrCreateInstance(headerCollapse, { toggle: false })
          collapse.hide()
        })
        headerDropdowns.forEach((headerDropdown) => {
          const dropdown = Dropdown.getOrCreateInstance(headerDropdown, { toggle: false })
          dropdown.hide()
        })
      }
    })
  }
  
  // On click outside main navigation, close all main navigation collapses
  const mainNavigationWrappers = Array.from(document.querySelectorAll('.main-navigation'))
  const mainNavigationCollapses = document.querySelectorAll('.main-navigation .collapse')
  if (mainNavigationWrappers && mainNavigationCollapses) {
    document.addEventListener('click', (event) => {
      const clickedMainNavigation = mainNavigationWrappers.some(wrapper => wrapper.contains(event.target))
      if (!clickedMainNavigation) {
        mainNavigationCollapses.forEach((mainNavigationCollapse) => {
          const collapse = Collapse.getOrCreateInstance(mainNavigationCollapse, { toggle: false })
          collapse.hide()
        })
      }
    })
  }

  // On click outside header and main navigation, close header offcanvas
  const header = document.querySelector('header')
  const headerOffcanvas = document.querySelector('#headerOffcanvas')
  if (header && headerOffcanvas) {
    document.addEventListener('click', (event) => {
      if (!header.contains(event.target) && !mainNavigationWrappers.some(wrapper => wrapper.contains(event.target))) {
        const offcanvasInstance = Offcanvas.getOrCreateInstance(headerOffcanvas, { toggle: false})
        offcanvasInstance.hide()
      }
    })
  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  handleOffcanvasEvents()
  handleMainNavigationEvents()
  handleKeyboardAndMouseEvents()
});